import {
  LIST_CATEGORY_OPERATIONS,
  LIST_FARM_CONCILIATIONS,
} from "redux/actions/actionsConstants";

export const INITIAL_STATE = {
  Conciliacoes: [],
  OperacoesCategoria: [],
};

export default (state = INITIAL_STATE, action) => {
  if (action.type === LIST_FARM_CONCILIATIONS) {
    return {
      ...state,
      Conciliacoes: action.payload.ConciliacoesFazenda,
    };
  } else if (action.type === LIST_CATEGORY_OPERATIONS) {
    return {
      ...state,
      OperacoesCategoria: action.payload.OperacoesCategoria,
    };
  }
  return state;
};
